<template>
    <span>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>

        <v-form>
            <div class="grid"
                 style="margin-left:5px;margin-bottom:20px;font-size:13px;color:burlywood">
                <span v-html="__('After clicking the :button button, prices on marketplace will be updated or queued for update (depending on the option selected)',
                    { 'button': updatePriceButton })
                    "></span>
            </div>
            <div class="grid">
                <FormInputNumber fieldName="new_price"
                                 label="New price"
                                 validation="required"
                                 size="12"
                                 :minFractionDigits="2"
                                 :maxFractionDigits="2"
                                 v-model:field="newPrice" />
            </div>


            <div class="grid"
                 style="margin-top:20px">
                <Button @click.stop="updatePrices"
                        type="button"
                        style="background-color:brown;margin:0 7px 0 5px"
                        severity="info">
                    <i class="fa-solid fa-coins"
                       style="margin-right:5px;font-size:18px"></i>
                    {{ __('Update prices') }}
                </Button>

                <Button severity="secondary"
                        style="margin:0 8px"
                        @click="cancel">
                    <i class="fa-solid fa-ban"
                       style="margin-right:5px;font-size:18px"></i>
                    {{ __('Cancel') }}
                </Button>
            </div>
        </v-form>
    </span>
</template>

<script setup>
import { ref } from 'vue'
import Button from 'primevue/button';
import FormInputNumber from '@crud/FormInputNumber.vue';
import { __, getFromRoute, screenMessage } from '@pages/Helper/utils.js'
import { validation, onErrorService } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    formProps: Object,
})

const isLoading = ref(false)
const isUpdatePriceModalOpen = defineModel('isUpdatePriceModalOpen')
const updatePriceButton = `<span style='font-weight:bold;'>"${__('Update prices')}"</span>`
const newPrice = ref(0)
const isQueued = ref(true)

// -----------------------------------------------------

const cancel = () => {
    isUpdatePriceModalOpen.value = false
}
// -----------------------------------------------------

const updatePrices = async () => {
    const formData = {
        new_price: newPrice.value, 'marketplaceCode': props.formProps.marketplace_code, 'isQueued': isQueued.value, selectedRows: props.formProps.selectedRows.map(row => {
            return { 'id': row.id }
        })
    }

    if (!validation(formData)) {
        return false
    }

    isLoading.value = true
    let response = null;

    try {
        response = await getFromRoute('offer-price-update', {
            'new_price': newPrice.value,
            'selectedRows': props.formProps.selectedRows.map(row => {
                return { 'id': row.id }
            })
        }, 'post');
        isLoading.value = false
        if (response?.status === 422 && response?.data?.errors) {
            onErrorService(response?.data?.errors)
            return false
        }
    } catch (error) {
        response = error?.response?.data?.error || error?.message || __('Unknown error occurred')
    }

    props.formProps.clearSelection()
    props.formProps.getLazyData()

    isUpdatePriceModalOpen.value = false
    isLoading.value = false

    const message = response?.success ? {
        message: response.success,
        title: "Information",
        type: "success",
        position: "center",
        timeout: 10,
    } : {
        message: response?.error,
        title: "Error",
        type: "error",
        position: "center",
        timeout: 15,
    }

    screenMessage(message)

}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
